import React from 'react';
import Types from 'constants/types';
import Header from '../common/Header';

import DateDisplay from './DateDisplay';
import DateTimeDisplay from './DateTimeDisplay';
import BooleanDisplay from './BooleanDisplay';
import DecimalDisplay from './DecimalDisplay';
import RichTextDisplay from './RichTextDisplay';

export default function LiteralDisplay({ field, mode }) {
  const { values, type } = field;
  if (type === Types.XSD.BOOLEAN) {
    return <BooleanDisplay field={field} mode={mode} />;
  }

  let Value;
  if (type === Types.XSD.DATETIME) {
    Value = ({value}) => <DateTimeDisplay value={value} />;
  } else if (type === Types.XSD.DATE) {
    Value = ({value}) => <DateDisplay value={value} />;
  }else if (type === Types.XSD.DECIMAL || type === Types.XSD.DOUBLE) {
	Value = ({value}) => <DecimalDisplay value={value} />;
  }
  else if (field?.props?.hyperLink) {
    Value = ({value}) => <a href={value} target="_blank">{value}</a>;
  }else if (field?.props?.richText) {
  	Value = ({value}) => <RichTextDisplay value={value} />;
  }else {
    Value = ({value}) => <span className="literal-value">{value}</span>;
  }

  return (
    <div className={`field ${mode}`} >
      <Header field={field} mode={mode} />
      <ul>
        {
          values.map((value, key) => (
            <li key={key}>
              <Value value={value} />
            </li>
          ))
        }
      </ul>
    </div>
  );
}
